// Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useEffect, useState } from 'react';
import { Platform, StyleSheet } from 'react-native';
import * as Linking from 'expo-linking';

import { Text, View } from '@/components/Themed';
import { useI18n } from '@/i18n';
import appColors from '@/theme/colors';

export default function DeepLinkDebugScreen() {
  const { t } = useI18n();
  const [latestUrl, setLatestUrl] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    Linking.getInitialURL()
      .then((url) => {
        if (active) setLatestUrl(url);
      })
      .catch(() => null);
    const subscription = Linking.addEventListener('url', ({ url }) => {
      setLatestUrl(url);
    });
    return () => {
      active = false;
      subscription.remove();
    };
  }, []);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t('debug.deeplinkTitle')}</Text>
      <Text style={styles.label}>{t('debug.deeplinkPlatform')}</Text>
      <Text style={styles.value}>{Platform.OS}</Text>
      <Text style={styles.label}>{t('debug.deeplinkLatest')}</Text>
      <Text style={styles.value}>{latestUrl ?? t('debug.deeplinkEmpty')}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 24,
    gap: 12,
    backgroundColor: appColors.background.app,
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: appColors.text.primary,
  },
  label: {
    fontSize: 13,
    fontWeight: '600',
    color: appColors.accent.soft,
  },
  value: {
    fontSize: 14,
    color: appColors.text.secondary,
  },
});
